import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MetadataService } from './services/metadata.service';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    routerSubscription: Subscription;
    private preloaderHidden = false;

    constructor(private router: Router, private metadata: MetadataService) {
    }

    ngOnInit(){
        this.recallJsFuntions();
    }

    ngOnDestroy() {
        this.routerSubscription?.unsubscribe();
    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            $.getScript('../assets/js/main.js');
            $.getScript('../assets/js/conversation.js');
            // The preloader only covers the initial app load; in-app navigation is instant.
            if (!this.preloaderHidden) {
                this.preloaderHidden = true;
                $('.preloader-area').fadeOut('slow');
            }
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            this.metadata.updateForRoute(event.urlAfterRedirects);
        });
    }

    skipToContent(event: Event) {
        event.preventDefault();
        document.getElementById('main-content')?.focus();
    }
}
